import { getAllStates } from '../index';
import { responder } from '../Components/Steps/StepCompleted';

/////////////////////////
// MAIN FUNCTION TO POST PAYLOAD TO CREDIT CARD API
/////////////////////////
export function postToApi() {

    // var success = false;

    // Acquire all data points (payload) that need to be sent to Credit Card API
    var app = getAllStates();

    function phoneStrip(phone) {
        return phone.replace(/[^a-zA-Z0-9/s]/g, '');
    }

    // function formateCCNumber(number) {
    //     return number.replace(/\s/g, '');
    // }

    function timeAtConvert(years, months) {
        var monthZeroed = months ? months : 0;
        return (years * 12) + parseInt(monthZeroed);
    }

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    });

    function moneyFormatter(money) {
        var stringify = money.toString();
        var stripper = stringify.replace(/\$|,/g, '');
        var float = parseFloat(stripper);
        var moneyed = formatter.format(float.toFixed(2));
        return moneyed.replace(/\$|,/g, '');
    }

    function employerCheck(employer) {
        if(app.employmentStatus === 'Self-Employed'){
            if(employer === '') {
                employer = "self";
            }
        }
        return employer;
    }

    function caEmployerCheck(caEmployer) {
        if(app.caEmploymentStatus === 'Self-Employed'){
            if(caEmployer === '') {
                caEmployer = "self";
            }
        }
        return caEmployer;
    }

    // function deNull(value) {
    //     return value ? value : "";
    // }

    var pT = app.ssn.replace(/[^a-zA-Z0-9/s]/g, '');
    var post_annual_income = moneyFormatter(app.annualIncome);

    if(app.monthlyPayment){
        var mp = moneyFormatter(app.monthlyPayment);
    }else{
        var mp = moneyFormatter(0.00);
    }

    var jsonData = {
        LoanType : "Credit Card",
        LoanProduct : app.product,
        RequestType : "New Credit Card (NCC)",
        userip: app.userip,
        // PromoCode: app.promoCode,
        Applicants : [{
            Primary : "true",
            FirstName : app.fname,
            LastName : app.lname,
            Email : app.email,
            Phones: [{
                PhoneType : app.phoneType,
                Phone : phoneStrip(app.phone)
            }],
            Address1 : app.address,
            City : app.city,
            State : app.state,
            ZipCode : app.zipcode,
            HomeOwnership : app.ownershipStatus,
            MonthlyPayment : mp,
            ResidenceTime : timeAtConvert(app.yearsAtAddress, app.monthsAtAddress),
            BirthDate : app.dob,
            SSN : pT,
            MaritalStatus : "Unknown",
            EmploymentStatus : app.employmentStatus,
            Employer : employerCheck(app.employer),
            EmploymentPosition : app.position,
            EmploymentLength : timeAtConvert(app.yearsEmployer, app.monthsEmployer),
            GrossIncome : moneyFormatter(post_annual_income),
            VWEmployee : String(app.vwEmployee)
        }]
    }
    
    if(app.coApp === "true") {

        var ca_ssn_app = app.ca_ssn;
        var capt = ca_ssn_app.replace(/[^a-zA-Z0-9/s]/g, '');

        if(app.caMonthlyPayment){
            var ca_mp = moneyFormatter(app.caMonthlyPayment);
        }else{
            var ca_mp = moneyFormatter(0.00);
        }

        jsonData.Applicants.push({
            Primary : "false",
            Relationship: app.coAppRelation,
            FirstName : app.ca_fname,
            LastName : app.ca_lname,
            Phones: [{
                PhoneType : app.caPhoneType,
                Phone : phoneStrip(app.caPhone)
            }],
            Email : app.ca_email,
            Address1 : app.caAddress,
            City : app.caCity,
            State : app.caState,
            ZipCode : app.caZip,
            HomeOwnership : app.caOwnershipStatus ? app.caOwnershipStatus : app.ownershipStatus,
            MonthlyPayment : ca_mp,
            ResidenceTime : timeAtConvert(app.caYears, app.caMonths) ? timeAtConvert(app.caYears, app.caMonths) : timeAtConvert(app.yearsAtAddress, app.monthsAtAddress),
            BirthDate : app.ca_dob,
            SSN : String(capt),
            // MaritalStatus : app.caMarital,
            EmploymentStatus : app.caEmploymentStatus,
            Employer : caEmployerCheck(app.caEmployer),
            EmploymentPosition : app.caPosition,
            EmploymentLength : timeAtConvert(app.caYearsEmployer, app.caMonthsEmployer),
            GrossIncome : moneyFormatter(app.caAnnualIncome),
            VWEmployee : String(app.caVWEmployee)
        });
    }

    ////Primary Applicant conditional fields

    if(app.mname){
        jsonData.Applicants[0].MiddleName = app.mname
    }

    if(app.address2) {
        jsonData.Applicants[0].Address2 = app.address2;
    }

    if(app.incomeSource){
        jsonData.Applicants[0].IncomeSource = app.incomeSource;
    }

    if(app.yearsUnemployed || app.monthsUnemployed){
        jsonData.Applicants[0].LengthUnemployment = parseInt(timeAtConvert(app.yearsUnemployed, app.monthsUnemployed));
    }

    //mailing address

    if(app.mailingAddress) {
        jsonData.Applicants[0].MailingAddress1 = app.mailingAddress;
    }

    if(app.mailingAddress2) {
        jsonData.Applicants[0].MailingAddress2 = app.mailingAddress2;
    }

    if(app.mailingCity) {
        jsonData.Applicants[0].MailingCity = app.mailingCity;
    }

    if(app.mailingState) {
        jsonData.Applicants[0].MailingState = app.mailingState;
    }

    if(app.mailingZipcode) {
        jsonData.Applicants[0].MailingZipCode = app.mailingZipcode;
    }

    ////Co-applicant conditional fields

    if(app.coApp === "true") {

        if(app.ca_mname) {
            jsonData.Applicants[1].MiddleName = app.ca_mname;
        }

        if(app.caAddress2) {
            jsonData.Applicants[1].Address2 = app.caAddress2;
        }

        //co-applicant mailing address

        if(app.coAppMailingAddress) {
            jsonData.Applicants[1].MailingAddress1 = app.coAppMailingAddress;
        }

        if(app.coAppMailingAddress2) {
            jsonData.Applicants[1].MailingAddress2 = app.coAppMailingAddress2;
        }

        if(app.coAppMailingCity) {
            jsonData.Applicants[1].MailingCity = app.coAppMailingCity;
        }

        if(app.coAppMailingState) {
            jsonData.Applicants[1].MailingState = app.coAppMailingState;
        }

        if(app.mailingZipcode) {
            jsonData.Applicants[1].MailingZipCode = app.mailingZipcode;
        }

        if(app.caIncomeSource){
            jsonData.Applicants[1].IncomeSource = app.caIncomeSource;
        }

        if(app.caYearsUnemployed || app.caMonthsUnemployed){
            jsonData.Applicants[1].LengthUnemployment = parseInt(timeAtConvert(app.caYearsUnemployed, app.caMonthsUnemployed));
        }

        if(app.coAppRelation === "Joint and Non-Spousal" || app.coAppRelation === "Co-signer and Non-Spousal") {
            jsonData.Applicants[1].RelationshipDetail = app.caRelation;
        }

    }

    if(app.authorizedUser === "yes"){
        var asArray = app.authorizedUserArray;
        var asPayload = [];
        for (var i = 0; i < asArray.length; i++) {
            let asSSN = asArray[i].SSN.replace(/[^a-zA-Z0-9/s]/g, '');
            let asObject = {
                FirstName: asArray[i].FirstName,
                MiddleName: asArray[i].MiddleName,
                LastName: asArray[i].LastName,
                BirthDate: asArray[i].DOB,
                SSN: String(asSSN)
            }
            asPayload.push(asObject);
        }
        jsonData.AuthorizedSigners = asPayload;
    }

    if (app.balanceTransfer === "yes") {
        var btArray = app.balanceTransferArray;
        var btPayload = [];
        for (var i = 0; i < btArray.length; i++) {
            let btObject = {
                LenderName: btArray[i].LenderName,
                // LenderAccount: formateCCNumber(btArray[i].LenderAccount),
                LenderAmount: moneyFormatter(btArray[i].LenderAmount)
                // LenderAddress: {
                //     Address1: btArray[i].Address,
                //     City: btArray[i].City,
                //     State: btArray[i].State,
                //     ZipCode: btArray[i].ZipCode
                // }
            }
            btPayload.push(btObject);
        }
        jsonData.BalanceTransfers = btPayload;
    }

    if (app.blockPromo === false) {
        if (app.promoCode) {
            jsonData.PromoCode = app.promoCode;
        }
    }

    var xhr = new XMLHttpRequest();

    xhr.open('POST', 'https://apps.vantagewest.org/NewApplication');

    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.setRequestHeader('VW_Token', '029a45c9f8ae78719f7cb70dc931d13c:33664d414f60954d15cefdd6c4ceace168d4e9ff7e5fcfa7a6aeb783c0fd7675');

    xhr.onload = function() {

       console.log(xhr.response);

       if (xhr.status === 200) {
            responder('success', xhr.response);
       }

       else if (xhr.status !== 200) {
            responder('failure', xhr.response);
       }

    };

    xhr.send(JSON.stringify(jsonData));

    //console.log(jsonData);
}